export default "__VITE_ASSET__C09Sj358__"